module.exports = __webpack_public_path__ + "static/media/figma.4d856e19.png";